module.exports = __webpack_public_path__ + "img/packing_material_1200x800.f96f5f46.svg";